import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {Navbar, Nav, NavDropdown, MenuItem} from 'react-bootstrap'
import LoadingBar from 'react-redux-loading-bar'
import {LOADER_BAR_COLOR} from "../../../settings/constants"
import logoIcon from '../../../_static/images/logo.png'
import cn from "classnames"
import {Link} from 'react-router-dom'
import {profileSelector, isAdminSelector, isAuthSelector, isTeacherOrganisationSelector} from "../../../modules/profile"
import {push} from 'react-router-redux'
import {logout, handleNonAuthLang} from "../../../modules/app"
import {checkQuestionsMenuDataItem, questionsId} from "../../../helpers/questionsMenu"
import {
    checkImportExportMenuDataItem,
    importId,
    exportId, 
    getExportModalTitle
} from "../../../helpers/importExport"
import {getMenuData} from '../../../helpers/menu'
import {IMPORT_EXPORT_QUESTIONS_MODAL, showModal, QBM_QUIZ, QBM_PRESENTATION} from "../../../modules/modals"
import {handleMassQuestionsState, exportListSelector} from "../../../modules/questions"
import {checkedCategoriesIdsSelector} from '../../../modules/categories'
import {questionsByCategorySelector} from '../../../modules/questions'
import {currentSubjectSelector} from "../../../modules/subjects"
import {routesUrls} from "../../../settings/routes"
import history from '../../../history'

class Header extends Component {
    render() {
        let {profile : {username} = {}, renderButtonNav, isAuth, CustomItems, isTeacherOrganisation, permission} = this.props
        let {formatMessage} = this.context

        let menu = Object.values(getMenuData());
        return (
            <header className="header header-qbm">
                <div className="loader-bar-wrapper">
                    <LoadingBar style={{backgroundColor: LOADER_BAR_COLOR}} />
                </div>
                <Navbar fixedTop className="navbar-qbm navbar-qbm-default">
                    <Navbar.Header>
                        <Navbar.Brand>
                            <Link to={routesUrls.dashboard}><img alt="QBM" src={logoIcon} /></Link>
                        </Navbar.Brand>
                        <Navbar.Toggle/>
                    </Navbar.Header>
                    <Navbar.Collapse>
                        
                        {
                         
                            <Nav className="navbar-qbm-nav-space__left">
                                {CustomItems ? <CustomItems /> : null}
                                {
                                   renderButtonNav ?  menu.filter((item, index) => {
                                       if(isTeacherOrganisation){
                                            if(!permission.add_new_question && item.id == 'import'){
                                                return false;
                                            } 
                                            if(item.id == 'export'){
                                                const submenus = menu[index].submenus;
                                                if(!permission.quizzes){
                                                    delete submenus.exportQuiz
                                                }
                                                if(!permission.lecture_hall){
                                                    delete submenus.exportPresentation
                                                }
                                                menu[index].submenus = submenus;
                                                return true;
                                            }
                                       }
                                       return true
                                   }).map(this.renderNavItemCB()) : null
                                }
                            </Nav>
                        }

                        {
                            this.renderRightMenu()
                        }

                        {
                            isAuth && (
                                <Navbar.Text
                                    className="navbar-qbm-greeting"
                                    pullRight
                                >
                                    <span className="navbar-qbm-greeting-text">{formatMessage('Hello')},</span>
                                    <span className="text-ellipsis">{username}</span>
                                </Navbar.Text>
                            )
                        }
                    </Navbar.Collapse>
                </Navbar>
            </header>
        )
    }

    renderRightMenu = () => {

        let {isAuth} = this.props
        let {formatMessage} = this.context

        return (
            <Nav pullRight>
                {
                    !isAuth && (
                        <Fragment>
                            <MenuItem
                                onClick = {this.navigate(routesUrls.signup)}
                                eventKey={7}
                            >{formatMessage("Sign Up")}</MenuItem>
                            <MenuItem
                                onClick = {this.navigate(routesUrls.login)}
                                eventKey={8}
                            >{formatMessage("Login")}</MenuItem>
                            <MenuItem
                                onClick = {() => {
                                    window.location.href = 'http://student.qbankmanager.com/'
                                }}
                                eventKey={8}
                            >{formatMessage("titleLoginStudent")}</MenuItem>
                            <NavDropdown
                                noCaret
                                eventKey={9}
                                title={formatMessage('Language')}
                                id="language-dropdown"
                            >
                                <MenuItem
                                    onClick = {this.changeLang('en-US')}
                                    eventKey={9.1}
                                >{formatMessage("English")}</MenuItem>
                                <MenuItem
                                    onClick = {this.changeLang('de-DE')}
                                    eventKey={9.1}
                                >{formatMessage("Deutsch")}</MenuItem>
                            </NavDropdown>
                        </Fragment>
                    )
                }

                {
                    this.renderNavDropdown()
                }
            </Nav>
        )
    }

    renderNavDropdown = () => {
        let {isAdmin, logout, isAuth} = this.props
        let {formatMessage} = this.context

        return isAuth && (
            <NavDropdown
                noCaret
                eventKey={4}
                title={this.AccountIcon}
                id="profile"
                className="ava-dropdown-folder"
            >
                <MenuItem onClick = {this.navigate(routesUrls.profile)} eventKey={4.1}>{formatMessage("Personal info")}</MenuItem>
                {
                    isAdmin && <MenuItem onClick = {this.navigate(routesUrls.adminTranslations)} eventKey={4.1}>{formatMessage("adminPanel")}</MenuItem>
                }
                <MenuItem onClick = {logout} eventKey={4.2}>{formatMessage("Logout")}</MenuItem>
            </NavDropdown>
        )
    }



    renderNavItemCB = (upperIndex, upperParentId) => function(item, index) {
        let eventKey = typeof upperIndex !== 'undefined' ? `${upperIndex}-${index}` : index
        let {id, text, submenus, checkCB, className = ""} = item
        let disabled = typeof checkCB === 'function' && !checkCB(this.props.hasSubject, this.props.hasQuestions) ? true : false
        return typeof submenus !== 'undefined' && !!Object.keys(submenus).length ?
            (
            <NavDropdown
                className={cn({"sub-dropdown-folder" : typeof upperIndex !== 'undefined'})}
                noCaret = {typeof upperIndex === 'undefined'}
                eventKey={eventKey}
                title={this.context.formatMessage(text)}
                id={id}
                key = {eventKey}
                disabled = {disabled}
            >
                {
                    Object.values(submenus).map(this.renderNavItemCB(eventKey, typeof upperParentId !== 'undefined' ? upperParentId : id))
                }
            </NavDropdown>
            ) :
            (
                <MenuItem
                    key = {eventKey}
                    eventKey={eventKey}
                    onClick={this._showModal(upperParentId)(id)}
                    className={cn(className)}
                >{this.context.formatMessage(text)}</MenuItem>
            )
    }.bind(this)

    AccountIcon = (
        <div className="account-icon-container">
            <div className="account-icon"></div>
            <div className="account-dropdown-icon">
                <div className={cn("account-dropdown-icon__arrow", {open : true})}></div>
            </div>
        </div>
    )

    _showModal = (menuId) => (submenuId) => () => {
        console.log("🚀 ~ file: index.js ~ line 211 ~ Header ~ menuId", menuId, submenuId, importId)

        if (!this._checkMenuDataItem(menuId, submenuId)) return
        const {showModal, handleMassQuestionsState, selectedQuestionIds} = this.props
        switch (true) {
            case submenuId == 'exportQuiz' : {
                showModal({
                    modalType : QBM_QUIZ,
                    modalProps : {
                        selectedQuestionIds
                    }
                })
                break;
            }
            case submenuId == 'exportPresentation' : {
                showModal({
                    modalType : QBM_PRESENTATION,
                    modalProps : {
                        selectedQuestionIds
                    }
                })
                break;
            }
            case menuId === importId : {
                if(submenuId == 'importQtizip'){
                    history.push(routesUrls.question_import);
                } else {
                    showModal({
                        modalType : IMPORT_EXPORT_QUESTIONS_MODAL,
                        modalProps : {
                            what : submenuId,
                            actionType : menuId
                        }
                    })
                }
                break
            }
            case menuId === exportId : {
                showModal({
                    modalType : IMPORT_EXPORT_QUESTIONS_MODAL,
                    modalProps : {
                        what : submenuId,
                        actionType : menuId,
                        title : getExportModalTitle(submenuId)
                    }
                })
                break
            }
            case menuId === questionsId : {
                handleMassQuestionsState(submenuId)
                break
            }
            default : {
                break
            }
        }
    }

    _checkMenuDataItem = (menuId, submenuId) => {
        return checkImportExportMenuDataItem(menuId, submenuId) || checkQuestionsMenuDataItem(menuId, submenuId)
    }

    navigate = (where) => () => {
        this.props.push(where)
    }

    changeLang = lang => () => this.props.handleNonAuthLang(lang)

    static contextTypes = {formatMessage: PropTypes.any}
}


export default connect(
    state => {
        const checkedCategoriesIds = checkedCategoriesIdsSelector(state)
        const exportList = exportListSelector(state, checkedCategoriesIds)
        const questions = questionsByCategorySelector(state, checkedCategoriesIds)
        return ({
            selectedQuestionIds : exportList.map(question => question.id),
            profile : profileSelector(state),
            isAdmin : isAdminSelector(state),
            hasQuestions : !!questions.length,
            hasSubject : !!currentSubjectSelector(state),
            isAuth : isAuthSelector(state),
            permission: state.profile.permission || {},
            isTeacherOrganisation: isTeacherOrganisationSelector(state),
        })
    },
    {push, logout, handleMassQuestionsState, showModal, handleNonAuthLang},
    null,
    {pure : false}
)(Header)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Header/index.js